// Calculate width according to different equipment
export var deviceWidth = document.body.clientWidth;
export var deviceHeight = document.body.clientHeight;
export var UIWidth = 375;
// Design draft width 375
var n = deviceWidth / UIWidth;
export var adjustDevice = function (value) {
    if (typeof value === 'number') {
        return value * n;
    }
    else {
        throw new Error('Expect number');
    }
};
export var ptHeight = function (height) { return (deviceHeight / 667) * height; };
